import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState,useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';

import clubMasterService from "../../../api/club.service";
import { DEFAULT_MASTER_DRAWER_WIDTH } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import CustomTableSearch from "../../common/CustomTableSearch";
import ClubEntry from "./ClubEntry";



const ClubList = () => {

  const dispatch = useDispatch();  
  const state = useSelector((state)=>state.club)
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  

  const [visible, setVisible] = useState(false);
  const [clubList, setClubList] = useState([]);
  const [clubData, setClubData] = useState({
      club_id: 0,
      designation:'',
      club_name: '',
      email: '',
      address:'',
      starting_affiliation_year:'',
      gstin:'',
});

  const showDrawer = (rowdata) => {  
 //   setProgrammeCommercialData(_);    

 setClubData({
      club_id: rowdata.club_id,
      designation:rowdata.designation,
      club_name: rowdata.club_name,
      email: rowdata.email,
      address:rowdata.address,
      starting_affiliation_year:rowdata.starting_affiliation_year,
      gstin:rowdata.gstin,   
      mode: "EDIT"
  })

    setVisible(true);

  };


  const onClose = () => {
    setVisible(false);
  };
 
  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: 'club_name',
      key: 'club_name',
      sorter: (a, b) => a.club_name.localeCompare(b.club_name),
    },
    {
      title: 'Designation',
      dataIndex: 'designation',
      key: 'designation',
      sorter: (a, b) => a.designation.localeCompare(b.designation),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),   
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    //   sorter: (a, b) => a.address.localeCompare(b.address),
    },   
    {
      title: 'Starting Affiliation Year',
      dataIndex: 'starting_affiliation_year',
      key: 'starting_affiliation_year',
      render: (text, record) => `${record.start_year} - ${record.end_year}`,      
    }, 
    {
        title: 'GSTIN',
        dataIndex: 'gstin',
        key: 'gstin',       
    },   
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        
        <Space size="middle">
          {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
          <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
        </Space>
      ),
    },
  ];


  useEffect(() => {
    clubMasterService.list().then((res) => {
      setClubList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [state.club])


  const onSearch = (e) => {
    const searchString = e.target.value.toLowerCase();
    const filteredList = clubList.filter(data => {       
        const startingAffiliationYear = `${data.start_year}-${data.end_year}`;      
        const isStartingAffiliationYearMatch = startingAffiliationYear.toLowerCase().includes(searchString);       
        const dataString = JSON.stringify(data).toLowerCase();       
        const isDataStringMatch = dataString.includes(searchString);    
        return isStartingAffiliationYearMatch || isDataStringMatch;
    });
    setFilteredSearchList(filteredList);
}

  return (
    <>
      <CustomTableSearch onSearchTable={onSearch}  />
      <Table 
        columns={columns} 
        rowKey='club_id' 
        dataSource={filteredSearchList} 
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        size="small"
        />

      <Drawer
          title="Edit Club"
          width={DEFAULT_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose = {true}
          closeIcon = {<><DrawableCloseIcon /></>}
        >
          <ClubEntry data={clubData} onDrawerClose={onClose}   />
        </Drawer>

    </>
  );
};

export default ClubList;